<template>
  <div class="home-landing">
    <div class="container">
      <div class="row min-vh-100 align-items-center justify-content-center">
        <div class="col-md-4 col-lg-3 text-center">
          <img :src="logoSrc" alt="Pam Logo" class="mb-5" style="width: 100px; height: 100px;" />

          <div v-if="loggedOut" class="alert alert-success mb-4 py-2" role="alert">
            <small><i class="bi bi-check-circle me-1"></i>Logged out successfully</small>
          </div>

          <router-link class="btn btn-primary btn-lg w-100" to="/login">
            Sign In
          </router-link>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'HomeView',
  components: { AppFooter },
  setup() {
    const route = useRoute();
    const loggedOut = ref(route.query.loggedOut === 'true');

    // Inject theme state from App.vue
    const isDarkMode = inject('isDarkMode', ref(true));

    // Determine logo based on theme
    const logoSrc = computed(() => {
      return isDarkMode.value
        ? require('@/assets/RJourneyWhiteIcon.png')
        : require('@/assets/RJourneyBlueIcon.png');
    });

    // Don't redirect here - let the router handle it
    // The navbar brand will link to /home when authenticated

    return { loggedOut, logoSrc };
  },
};
</script>

<style scoped>
.home-landing {
  min-height: 100vh;
  display: flex;
  align-items: center;
}
</style>

<style scoped></style>
